import React from 'react';
import { useTranslation } from 'react-i18next';
import { HistoryFeesTableRow } from '../../../components/merchants/HistoryFeesTableRow';
import { useMerchants } from '../../../store/merchnts/merchants-context';
import { SectionWrapper } from '../../../components/SectionWrapper';
import { TableComponent } from '../../../components/TableComponent';
import { IHistoryFeesData } from '../../../interfaces/merchant';

const COLUMNS = [
	{
		key: 'date',
		title: 'FEES.DATE',
		additionalColumnClassName: 'w-100px',
	},
	{
		key: 'name',
		title: 'FEES.NAME',
		additionalColumnClassName: 'w-100px',
	},
	{
		key: 'amount',
		title: 'FEES.AMOUNT',
	},
];

export const MerchantFeesHistoryPage = (): JSX.Element => {
	const { merchantState: { historyFeesData }} = useMerchants();
	const { t } = useTranslation();
	return (
		<SectionWrapper
			title={t('MERCHANT.FEES_HISTORY')}
			isCardBody
		>
			<TableComponent
				column={COLUMNS}
				tableData={historyFeesData}
				getRowComponent={(item: IHistoryFeesData): JSX.Element => (
					<HistoryFeesTableRow
						key={item.id}
						{...item}
					/>
				)}
			/>
		</SectionWrapper>
	);
};
